import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { ComponentSelectDecoratorViewModel } from "./componentSelectDecorator-viewModel";

export class CompactView extends View<ComponentSelectDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-0EC7CF29-E8FE-49F1-B837-ED4C4EACC31B"
    }
    loadHtml(): string {
        let element = require('./compact.html').default;
        let style = require('./compact.less');
        return element;
    }
    constructor() {
       super();
    }

    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
    public set IsElementSelected(v: boolean) { this._IsElementSelected = v; } public get IsElementSelected(): boolean { return this._IsElementSelected;} private _IsElementSelected: boolean;

    decoratorClicked(e:Event){
        e.stopPropagation();
        this.dataContext.decoratorClicked();
    }
}
